export default "__VITE_ASSET__C5G1BCzi__"